
<div class="modal-dialog confirm-dialog">
  <div class="modal-content" style="min-width:600px;">
    <form #projectForm="ngForm" (ngSubmit)="save()">
      <div class="modal-header">
        <h4 class="modal-title">Create a Project</h4>
        <button class="close" type="button" (click)="cancel()">&times;</button>
      </div>
      <div class="modal-body">
        <error [error]="error"></error>
        <form [formGroup]="form">
          <div class="row">
            <div class="form-group col">
              <label class="required" for="nameField">Project Name</label>
              <input class="form-control" id="nameField" type="text" formControlName="projectName" name="name" maxlength="40" required>
            </div>
          </div>
          <div class="row">
            <div class="form-group col">
              <label>Region</label>
              <div class="form-check" *ngFor="let region of regions">
                <input class="form-check-input" type="radio" name="region" formControlName="region" value="{{ region.value }}" autoLinkToLabel required (change)="onChangeRegion()">
                <label class="form-check-label">{{ region.title }}</label>
              </div>
            </div>
            <div class="form-group col">
              <label>Target System</label>
              <tree-select *ngIf="POR_373" [inputId]="selectTargetSystem" formControlName="targetSystem" [inputName]="selectTargetSystem" [(ngModel)]="targetSystemVal" [POR190]="POR_190" required></tree-select>
              <ng-container *ngIf="!POR_373">
                <div class="form-check" *appSetting="'enableSimplify'">
                  <input class="form-check-input" type="radio" name="targetSystem" formControlName="targetSystem" value="pmpsc" autoLinkToLabel required (change)="onChangeTarget()">
                  <label class="form-check-label">Partner MPS (Managed Complete)</label>
                </div>
                <div class="form-check" *appSetting="'enableManagePage'">
                  <input class="form-check-input" type="radio" name="targetSystem" formControlName="targetSystem" value="pmpsp" autoLinkToLabel required (change)="onChangeTarget()">
                  <label class="form-check-label">Partner MPS (Managed Page)</label>
                </div>
                <div class="form-check" *ngIf="POR_190"> 
                  <input class="form-check-input" type="radio" name="targetSystem" formControlName="targetSystem" value="mpflexr" autoLinkToLabel required (change)="onChangeTarget()">
                  <label class="form-check-label">Partner MPS (MPFlexr)</label>
                </div>
                <div class="form-check" *appSetting="'enableDmpsWorkflow'">
                  <input class="form-check-input" type="radio" name="targetSystem" formControlName="targetSystem" value="dmps" autoLinkToLabel required (change)="onChangeTarget()">
                  <label class="form-check-label">Direct MPS</label>
                </div>
                <div class="form-check" *appSetting="'enableDaas'">
                  <input class="form-check-input" type="radio" name="targetSystem" formControlName="targetSystem" value="daas" autoLinkToLabel required (change)="onChangeTarget()">
                  <label class="form-check-label">DaaS</label>
                </div>
                <div class="form-check" *appSetting="'enableDaas'">
                  <input class="form-check-input" type="radio" name="targetSystem" formControlName="targetSystem" value="midaas" autoLinkToLabel required (change)="onChangeTarget()">
                  <label class="form-check-label">Migrating DaaS (DaaS)</label>
                </div>
                <div class="form-check" *appSetting="'enableMigration'">
                  <input class="form-check-input" type="radio" name="targetSystem" formControlName="targetSystem" value="momc" autoLinkToLabel required (change)="onChangeTarget()">
                  <label class="form-check-label">Migrating Orion (Managed Complete)</label>
                </div>
                <div class="form-check" *appSetting="'enableMigration'">
                  <input class="form-check-input" type="radio" name="targetSystem" formControlName="targetSystem" value="midmps" autoLinkToLabel required (change)="onChangeTarget()">
                  <label class="form-check-label">Migrating IPSO (dMPS)</label>
                </div>
                <div class="form-check" *appSetting="'enableMigration'">
                  <input class="form-check-input" type="radio" name="targetSystem" formControlName="targetSystem" value="mimc" autoLinkToLabel required (change)="onChangeTarget()">
                  <label class="form-check-label">Migrating IPSO (Managed Complete)</label>
                </div>
                <div class="form-check" *appSetting="'enableMigration'">
                  <input class="form-check-input" type="radio" name="targetSystem" formControlName="targetSystem" value="mimp" autoLinkToLabel required (change)="onChangeTarget()">
                  <label class="form-check-label">Migrating IPSO (Managed Page)</label>
                </div>
              </ng-container>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button class="btn btn-primary" type="submit" [attr.disabled]="!form.valid ? true : null">Save</button>
        <button class="btn btn-outline-secondary" type="button" (click)="cancel()">Cancel</button>
      </div>
    </form>
  </div>
</div>